














import {
  getProjectPropertyKeys,
  ProjectPropertyKey
} from "@/api/project/project-properties-api";
import ProjectPropertyKeyTable from "@/components/project/property/ProjectPropertyKeyTable.vue";
import VToolbar from "@/components/VToolbar.vue";
import { Component, Vue } from "vue-property-decorator";

/**
 * 現場のプロパティキーの一覧ページ
 */
@Component({
  components: {
    VToolbar,
    ProjectPropertyKeyTable
  }
})
export default class ProjectPropertyKeyListPage extends Vue {
  keys: ProjectPropertyKey[] = [];

  public created() {
    this.initKeys();
  }

  get availableKeys() {
    return this.keys.filter(k => !k.deletedAt);
  }

  async initKeys() {
    this.keys = await getProjectPropertyKeys();
  }
}
